export const FuelData = [
    {
        code: 4243,
        name: 'Olej napędowy',
        order: 0,
        color: '#252525'
    },
    {
        code: 4241,
        name: 'Benzyna 95',
        order: 1,
        color: '#82c76d'
    },
    {
        code: 4244,
        name: 'LPG',
        order: 2,
        color: '#ba5959'
    },
    {
        code: 4242,
        name: 'Benzyna 98',
        order: 3,
        color: '#383875'
    },
    {
        code: 9521,
        name: 'Olej napędowy +',
        order: 4,
        color: '#387549'
    },
    {
        code: 4245,
        name: 'AdBlue',
        order: 5,
        color: '#72b6cf'
    },
]